import { useProcessorDataContext } from '../contexts/processor-data.context';
import { useScopedTrackingIds } from './use-scoped-tracking-ids';

export const PACKAGE_TRACKING_ID = 'payments-platform';

/**
 * Scopes key=>value pairs to tracking IDs for the Payments Platform package.
 * Key => Base package ID + component name + active gateway + value.
 */
export const usePaymentsPlatformTrackingIds = <O extends object>(componentName: string, map: O) => {
  const { activeGateway } = useProcessorDataContext();
  return useScopedTrackingIds(`${PACKAGE_TRACKING_ID}:${componentName}:${activeGateway}`, map);
};
